import { useEffect } from "react";
import { useRealtimeStore } from "./store.js";

export const useSessionBoot = (accountId: string | null, wsUrl: string): void => {
  const connect = useRealtimeStore((state) => state.connect);
  const disconnect = useRealtimeStore((state) => state.disconnect);

  useEffect(() => {
    if (!accountId) {
      disconnect();
      return;
    }
    connect(accountId, wsUrl);
    return () => {
      disconnect();
    };
  }, [accountId, connect, disconnect, wsUrl]);
};
